import { makeStyles } from "@mui/styles"
import React, { ReactNode } from "react"

interface IProps {
  children: ReactNode;
  className: string;
}

export const DefaultLayout = (props: IProps) => {

  const { children, className } = props

  const classes = makeStyles({
    container: {
      paddingLeft: "65px",
      paddingTop: "55px",
    }
  })()

  return (
    <div className={`${classes.container} ${className} default-layout`}>{children}</div>
  )
}
